import React from "react";
import AuthForm from "./components/AuthForm";

function SignIn() {
  return <AuthForm isSignUp={false} />;
}

export default SignIn;
